const styles = {
    display: "flex",
    justifyContent: "end",
    flexDirection: "column",
    gap: "12px",
    backgroundColor: "transparent"
};
const inputStyles = {
    padding: "clamp(12px, 2vw, 16px)",
    paddingLeft: "clamp(14px, 2.5vw, 19px)",
    borderRadius: "5px",
    color: " #7f7f7f",
    fontFamily: "var(--font-paragraph)"
};
const uploadBtnStyles = {
    backgroundColor: "transparent",
}
const labelStyles = {
    color: "black",
    fontWeight: "700",
    fontFamily: "var(--font-label",
    fontSize: "var(--font-label-size)"
};

export { styles, inputStyles, uploadBtnStyles, labelStyles };